module.exports = "/remote-dist/6308e1758739cd109cc3888188735cd4.png";